import styled from "styled-components";
import { H1 } from "../../shared/globals";

export const CenterWrapper = styled.div`
  display: flex;
  align-items: center;
  place-content: center;
  background-color: none;
`;

export const HeadText = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  place-content: center;
  text-align: center;
  padding: 60px 0 40px 0;
`;

export const Text = styled(H1)`
  color: ${({ theme }) => theme.text.default};
  font-size: 34px;
  font-weight: bold;
`;
